import script from "./ProfessionalProjects.vue?vue&type=script&setup=true&lang=js"
export * from "./ProfessionalProjects.vue?vue&type=script&setup=true&lang=js"

import "./ProfessionalProjects.vue?vue&type=style&index=0&id=5c87249c&lang=scss&scoped=true"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5c87249c"]])

export default __exports__